import { connect } from 'react-redux';
import * as R from 'ramda';
import Sidebar from './Sidebar';
import {
  fetchAuthorizationSequencingCards,
  fetchUniqueSelectors,
  getCurrentSelection,
  getSelectorsData,
  getStoreValueByProp,
  resetAuthSequencing,
  setAuthorizationSequencingPending,
  setFiltersOpen,
} from '../store/authorizationSequencingSlice';
import { resetCardFilters, setFilters } from '../../filters/store/filtersSlice';

const mapState = R.applySpec({
  authorizationSequencingPending: getStoreValueByProp(['authorizationSequencingPending']),
  currentSelection: getCurrentSelection,
  relatedIds: R.path(['loadingManagement', 'filters', 'relatedIds']),
  selectorsList: getSelectorsData,
  selectorsListPending: getStoreValueByProp(['selectorsListPending']),
  selectorsListRaw: getStoreValueByProp(['selectorsList']),
});

const mapDispatchToProps = {
  fetchAuthorizationSequencingCards,
  fetchUniqueSelectors,
  resetAuthSequencing,
  resetCardFilters,
  setAuthorizationSequencingPending,
  setFilters,
  setFiltersOpen,
};

export default connect(mapState, mapDispatchToProps)(Sidebar);
